import React from 'react';
import PropTypes from 'prop-types';
import { create } from 'jss';
import { Global, css } from '@emotion/core';
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
  StylesProvider,
  jssPreset,
  createGenerateClassName,
} from '@material-ui/core/styles';

import THEME, { typography } from '$variables/theme';
import COLORS from '$variables/colors';

const jss = create({
  ...jssPreset(),
  // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
  insertionPoint: 'custom-insertion-point',
});

const generateClassName = createGenerateClassName({
  productionPrefix: 'ssa',
});

const globalStyles = css`
  html {
    height: 100%;
  }
  body {
    margin: 0px;
    font-family: ${typography.fontFamily};
    font-size: 14px;
    display: flex;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  #root {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
    background-color: ${COLORS.whiteSmoke};
  }
  .tooltip {
    font-family: ${typography.fontFamily};
  }
`;

const ThemeProvider = ({ children }) => (
  <>
    <Global styles={globalStyles} />
    <StylesProvider jss={jss} generateClassName={generateClassName}>
      <MuiThemeProvider theme={createTheme(THEME)}>{children}</MuiThemeProvider>
    </StylesProvider>
  </>
);

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeProvider;
